import React, { useState } from 'react'
import {
  Heading,
  Spinner,
  VStack,
  IconButton,
  SlideFade,
  Button,
} from '@chakra-ui/react'
import { ChevronRightIcon } from '@chakra-ui/icons'
import { withRouter } from 'react-router-dom'
import Typed from 'react-typed'
import Sound from '@sidpagariya/react-sound'

const ScribblIo = (props) => {
  let [doneLoading, setDoneLoading] = useState(false)
  let [doneTyping, setDoneTyping] = useState(false)
  let [nextRevealed, setNextRevealed] = useState(false)
  let [volume, setVolume] = useState(50)
  let delayT = 100

  const onLoad = () => {
    setDoneLoading(true)
  }

  if (volume < 50 && volume > 0) {
    setTimeout(() => setVolume(volume - 5), delayT)
  }

  return (
    <VStack spacing={8}>
      {doneLoading ? (
        <Heading fontSize="3xl" whiteSpace="pre" lineHeight="tall">
          <Typed
            strings={[
              'Phew^100' +
                '.^100' +
                '.^100' +
                '.^1500\n' +
                [
                  'Well that was a fun time speed dating!✨^1000',
                  'Or so I hope 😂^1250',
                  'Okay...^2000',
                  'This might actually be fun hahaha^1750',
                  "Let's take a look!",
                ].join('\n'),
            ]}
            smartBackspace
            typeSpeed={40}
            backSpeed={50}
            backDelay={1000}
            onComplete={() => {
              setTimeout(() => setVolume(volume - 5), 5000 + delayT)
              setDoneTyping(true)
            }}
          />

          <br />
          <br />

          <SlideFade in={doneTyping}>
            <Button
              onClick={() => {
                window.open('https://skribbl.io/?0lLFGMXoer5Q')
                setNextRevealed(true)
              }}
            >
              A mini-game, shall we?
            </Button>
          </SlideFade>
          <SlideFade in={nextRevealed}>
            <IconButton
              variant="outline"
              colorScheme="blue"
              aria-label="Next Screen"
              icon={<ChevronRightIcon />}
              onClick={() => props.history.push('/movie')}
            />
          </SlideFade>
        </Heading>
      ) : (
        <Spinner size="xl" />
      )}
      <Sound
        url="/candyland.mp3"
        playStatus={Sound.status.PLAYING}
        volume={volume}
        onLoad={onLoad}
        playFromPosition={15000}
      />
    </VStack>
  )
}

export default withRouter(ScribblIo)
